"use client";
import React from "react";
import Header from "./common/web/Header";
import MobileOptions from "./common/web/MobileOptions";
import Footer from "./common/web/Footer";
import ScrollToTop from "./common/ScrollToTop";
import { usePathname } from "next/navigation";
import { Toaster } from "react-hot-toast";

export default function MainPage({ children }) {
    let pathname = usePathname();
    let isadmin = pathname.includes("/pages/admin");
    let isauthpage = pathname.includes("/pages/web/auth");
    return (
        <div>
            <ScrollToTop />
            {isadmin || isauthpage ? null : <Header />}
            {isadmin || isauthpage ? null : <MobileOptions />}
            {children}
            {isadmin || isauthpage ? null : <Footer />}
            <Toaster />
        </div>
    );
}
